exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable.details td {\n  padding-left: 3px;\n  padding-right: 3px;\n  font-size: 11px;\n  line-height: 1.3em;\n  height: 15px;\n}\n.drop.over {\n  border-color: #aaa;\n  background: #ccc;\n}\n.drag {\n  cursor: grab;\n  font-size: 12px;\n}\n.record-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 6px;\n  padding: 4px 6px;\n  background: #fdfdfd;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n}\n.record-actions {\n  display: flex;\n  align-items: center;\n}\n", ""]);

// exports
